export class CatalogDataQualityChartGroup {
  constructor(
    public id?: string,
    public category?: string,
    public productCount?: number,
    public filter?: string
  ) {
  }
}
